<!--购买渠道下拉框-->
<script>
import api from "@/api/projectApi";

export default {
  name: 'buyChannelSelect',
  props: ['buyChannelId'],
  mounted() {
    this.loadData()
  },
  data() {
    return {
      options: []
    }
  },
  methods: {
    changeSelect() {
      this.$emit('update:buyChannelId', this.buyChannelId)
    },

    clear() {
      this.$emit('update:buyChannelId', null)
    },

    loadData() {
      this.$http.post(api.basBuyChannel.getListDataUrl, {}).then(res => {
        this.options = res.data.data
      })
    }
  }
}
</script>

<template>
  <div>
    <el-select v-model="buyChannelId" @change="changeSelect" @clear="clear" filterable :clearable="true">
      <el-option v-for="item in options"
                 :key="item.id"
                 :label="item.buyChannelName"
                 :value="item.id"
      ></el-option>
    </el-select>
  </div>
</template>

<style scoped lang="scss">

</style>
